/**
 * Calculate a rolling mean (average) for a single element of an array.
 *
 * @example
 * const numbers = [1,2,3,4,5];
 * const mean = numbers.reduce((previous, current, index) => rollingMean(previous, current, index));
 * @see http://stackoverflow.com/a/1934266
 * @param previousMean - The previous average value
 * @param value - The value to incorporate into the average
 * @param previousCount - The number of items that were used to calculate
 * the previous mean (or the index of the element within its
 * containing array).
 * @returns The new mean
 */
export function rollingMean(previousMean: number, value: number, previousCount: number): number {
    const alpha = (value - previousMean) / (previousCount + 1);
    return previousMean + alpha;
}
